module.exports = __webpack_public_path__ + "static/img/kefu02.366ddb5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/kefu02.png
// module id = zkfP
// module chunks = 26